import { RecoilAtoms } from "../config/recoil-atoms";
import { atom } from "recoil";

export const isPremiumModalOpenAtom = atom<boolean>({
  key: RecoilAtoms.IS_PREMIUM_MODAL_OPEN,
  default: false,
});
